export function initCookieBanner() {
    const links = document.querySelectorAll('a[href*="cookiesettings"]');
    links.forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
                window.Cookiebot.renew();
            } else {
                console.warn('Cookiebot or Cookiebot.renew() is not available.');
            }
        });
    });
}